// src/app/uiSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { sanitizeCompanyLogoUrl } from '../functions/companyLogoUrl';

const initialState = {
  companyLogoUrl: sanitizeCompanyLogoUrl(null),
  backButtonUrl: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setCompanyLogoUrl(state, action) {
      state.companyLogoUrl = sanitizeCompanyLogoUrl(action.payload ?? null);
    },
    setBackButtonUrl(state, action) {
      state.backButtonUrl = action.payload;
    },
  },
});

export const { setCompanyLogoUrl, setBackButtonUrl } = uiSlice.actions;
export default uiSlice.reducer;
